// extracted by mini-css-extract-plugin
export default {"Accordion":"recipe-style_Accordion__WBv8o","Ingr":"recipe-style_Ingr__J1Prq","Tags":"recipe-style_Tags__+KDdh"};